import { Box } from "@mui/material";
import { useIsMobile } from "../../hooks/useIsMobile";
import other from "../../designTokens/other.esm";

export const PageContainer = ({ children, expand = false, sx }) => {
  const isMobile = useIsMobile("xl");

  // expand 모드일 때는 더 넓은 컨테이너 사용
  const containerWidth = expand
    ? isMobile
      ? "100%"
      : "min(1400px, 90vw)"
    : isMobile
    ? "100%"
    : other.size.lg;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: containerWidth,
        boxSizing: 'border-box',
        minWidth: 0,
        minHeight: "calc(100vh - 62px)",
        padding: isMobile ? "16px 16px 0 16px" : "24px 0 0 0",
        margin: "0 auto", // 중앙 정렬
		...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "80px",
          paddingTop: isMobile ? "24px" : "32px",
          paddingBottom: "64px",
          // overflowX: "hidden", // 제거 - 로고 등이 잘림
          width: "100%",
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
